import { render, staticRenderFns } from "./DeleteShiftReport.vue?vue&type=template&id=6b05e04f&scoped=true&"
import script from "./DeleteShiftReport.vue?vue&type=script&lang=js&"
export * from "./DeleteShiftReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05e04f",
  null
  
)

export default component.exports